import { __decorate } from "tslib";
import { Accordion } from '@microsoft/fast-foundation';
import { attr } from '@microsoft/fast-element';
import { ChameleonElementMixin } from '../common/ChameleonElement';
export class AccordionComponent extends ChameleonElementMixin(Accordion) {
    constructor() {
        super(...arguments);
        this.outlined = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.propagateSizeAttribute(this.getAttribute('size'));
    }
    sizeChanged(_oldValue, newValue) {
        this.propagateSizeAttribute(newValue);
    }
    propagateSizeAttribute(newSize) {
        const accordionItems = this.querySelectorAll('chameleon-accordion-item');
        accordionItems === null || accordionItems === void 0 ? void 0 : accordionItems.forEach((accordionItem) => {
            if (newSize) {
                accordionItem.setAttribute('size', newSize);
            }
            else {
                accordionItem.removeAttribute('size');
            }
        });
    }
}
__decorate([
    attr
], AccordionComponent.prototype, "size", void 0);
__decorate([
    attr({ mode: 'boolean' })
], AccordionComponent.prototype, "outlined", void 0);
